module.exports = __webpack_public_path__ + "images/e39554bce1080fc30b538f57aa9cc4db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/coach_plus_logo.jpg
// module id = 1277
// module chunks = 0